import { FormEvent } from 'react'
import { TextField, IconButton, Icon } from '@leroy-merlin-br/backyard-react'
import { AirplaneOutline } from '@backyard-ui/icons'

import { TrailingLoading } from '../Icons'
import * as S from './styled'
import { ChatForm, ChatFormData } from './types'

const FormInput = ({ onSubmit, isWaiting }: ChatForm) => {
  const changeTrack = (evt: FormEvent) => {
    const el = evt.target as HTMLElement
    el.style.height = el.scrollHeight + 'px'
  }

  const submitEvent = async (e: FormEvent) => {
    e.preventDefault()

    const values: ChatFormData = {
      message: ''
    }

    const formData = new FormData(e.target)
    formData.forEach((value: FormDataEntryValue, key: string) => {
      values[key] = value
    })
    onSubmit(values)
  }

  return (
    <form onSubmit={submitEvent}>
      <TextField
        rows={1}
        cols={10}
        minLength={3}
        maxLength={220}
        autoFocus
        as="textarea"
        name="message"
        placeholder="digite sua mensagem"
        required
        css={S.inputStyles}
        renderSuffix={(renderProps) => (
          <IconButton
            {...renderProps}
            appearance="primary"
            as="button"
            label="Enviar"
            size="kilo"
            type="submit"
            variant="ghost"
            css={S.buttonStyles}
          >
            {isWaiting ? (
              <TrailingLoading />
            ) : (
              <Icon color="primary" as={AirplaneOutline} />
            )}
          </IconButton>
        )}
        onChange={changeTrack}
      />
    </form>
  )
}

export default FormInput
